export const Realtime = {
  connectionError: "Connection error",
  connectionError1: "We're sorry, an internal connection error has occurred.",
  connectionError2: "Please try again later or contact support.",
};
